var UrgencyAddon = (function ($) {

    var URGENCY_ORDER_SELECTOR = ".urgency-orders";
    var URGENCY_VISITORS_SELECTOR = ".urgency-visitors";
    var URGENCY_JUST_BOUGHT_SELECTOR = ".urgency-just-bought";

    var initOrdersUrgency = function (selector) {

        if (!selector) {
            selector = URGENCY_ORDER_SELECTOR;
        }

        if (!$(selector).length) {
            return;
        }

        makeRequest(selector, "/urgency/orders", function (data, ordersBlocks) {
            var productData = data.reduce(function (map, obj) {
                map[obj.productId] = [obj.count, obj.latestOrder, obj.latestOrderUnit];
                return map;
            }, {});

            ordersBlocks.each(function () {
                var productId = $(this).data("product-id");
                if (productId && productData[productId]) {
                    var ordersCountMsg = ACC.getParametrizedString(ACC.urgencyOrdersCount, productData[productId][0]);
                    var lastOrderMsg = ACC.getParametrizedString(ACC.urgencyLatestOrder, productData[productId][1], getLatestOrderUnit(productData[productId][2]));
                    $(this).find(".urgency-orders-count").text(ordersCountMsg);
                    $(this).find(".urgency-latest-order").text(lastOrderMsg);
                    $(this).css({"display": "flex"});
                }
            });
            initBlockSizes(selector);
        });
    };

    var initVisitorsUrgency = function (selector) {

        if (!selector) {
            selector = URGENCY_VISITORS_SELECTOR;
        }

        if (!$(selector).length) {
            return;
        }

        makeRequest(selector, "/urgency/visitors", function (data, visitorsBlocks) {
            var productData = data.reduce(function (map, obj) {
                map[obj.productId] = [obj.count];
                return map;
            }, {});

            visitorsBlocks.each(function () {
                var productId = $(this).data("product-id");
                if (productId && productData[productId]) {
                    var message = ACC.getParametrizedString(ACC.urgencyVisitorsCount, productData[productId]);
                    $(this).find(".urgency-visitors-count").text(message);
                    $(this).css({"display": "flex"});
                }
            });
        });
    };

    var initJustBoughtUrgency = function (selector) {
        if (!selector) {
            selector = URGENCY_JUST_BOUGHT_SELECTOR;
        }

        if (!$(selector).length) {
            return;
        }

        makeRequest(selector, "/urgency/orders/last", function (data, justBoughtBlocks) {
            var productData = data.reduce(function (map, obj) {
                map[obj.productId] = [obj.justBought, obj.latestOrder, obj.latestOrderUnit];
                return map;
            }, {});

            justBoughtBlocks.each(function () {
                var productId = $(this).data("product-id");
                if (productId && productData[productId]) {
                    var message = ACC.getParametrizedString(ACC.urgencyLatestOrder, productData[productId][1], getLatestOrderUnit(productData[productId][2]));
                    if (productData[productId][0]) {
                        $(this).find(".urgency-messages").prepend('<div class="urgency-just-bought-text">' + ACC.urgencyJustBought + '</div>');
                    }
                    $(this).find(".urgency-latest-order").text(message);
                    $(this).css({"display": "flex"});
                }
            });
            initBlockSizes(selector);
        });
    };

    var makeRequest = function (selector, url, successCallback) {
        var blocks = $(selector);
        if (!blocks.length) {
            return;
        }

        var productIds = [];
        blocks.each(function () {
            var productId = $(this).data("product-id");
            if (productId) {
                productIds.push(encodeURIComponent(productId));
            }
        });

        if (!productIds.length) {
            return;
        }

        let urgencyData = getLocalStorageUrgencyByIds(productIds);
        urgencyData = JSON.stringify(urgencyData);
        $.ajax({
            type: "POST",
            url: url,
            beforeSend: function(xhr) {
                xhr.setRequestHeader("X-CSRF-TOKEN", $("input[name='_csrf']").val());
            },
            contentType: "application/json",
            data: urgencyData,
            success: function (data) {
                if (successCallback) {
                    successCallback(data.displayData, blocks);
                }
                setLocalStorageUrgencyByIds(data.urgencyData, productIds)
            }
        });
    };

    var getLocalStorageUrgencyByIds = function (productIds) {
        let storedUrgencyData = getLocalStorageUrgencyData();
        let urgencyData = {};

        productIds.forEach(productId => {
            urgencyData[productId] = storedUrgencyData[productId] || {};
        });
        return urgencyData;
    };

    var setLocalStorageUrgencyByIds = function (urgencyData, productIds) {
        let storedUrgencyData = getLocalStorageUrgencyData();

        productIds.forEach(productId => {
            if (urgencyData[productId] !== undefined) {
                storedUrgencyData[productId] = urgencyData[productId];
            }
        });
        window.localStorage.setItem('urgencyData', JSON.stringify(storedUrgencyData));
    };

    var getLocalStorageUrgencyData = function () {
        let storedUrgencyData = JSON.parse(window.localStorage.getItem('urgencyData'));
        if (storedUrgencyData === null) {
            storedUrgencyData = {};
        }

        return storedUrgencyData;
    }

    var getLatestOrderUnit = function (unitMessage) {
        if ("SECONDS" == unitMessage) {
            return ACC.urgencyLatestOrderSeconds;
        } else if ("MINUTES" == unitMessage) {
            return ACC.urgencyLatestOrderMinutes;
        } else {
            return ACC.urgencyLatestOrderHours;
        }
    };

    var raiseWidget = function (selectorToRaise, relative) {
        if (!relative) {
            relative = URGENCY_ORDER_SELECTOR;
        }

        if (!selectorToRaise) {
            selectorToRaise = URGENCY_JUST_BOUGHT_SELECTOR;
        }

        $(".urgency-wrapper").each(function () {
            var first = $(this).find(relative);
            var second = $(this).find(selectorToRaise);

            if ((first.length && second.length)
                && ($(first).is(':visible') && $(second).is(':visible'))) {
                first.hide()
            }
        });
    };

    var initBlockSizes = function (urgencyWrapper) {
        $(urgencyWrapper).children('.urgency-messages').each(function (index, item) {
            var maxTextWidth = 0;
            $(item).find("div").each(function (messageIndex, message) {
                maxTextWidth = Math.max(maxTextWidth, message.getBoundingClientRect().width);
            });
            $(item).css({
                "min-width": maxTextWidth + 'px'
            });
        });
    };

    return {
        orderSelector : URGENCY_ORDER_SELECTOR,
        boughtSelector : URGENCY_JUST_BOUGHT_SELECTOR,
        initOrdersUrgency: initOrdersUrgency,
        initVisitorsUrgency: initVisitorsUrgency,
        initJustBoughtUrgency: initJustBoughtUrgency,
        initBlockSizes: initBlockSizes,
        raiseWidget: raiseWidget
    }

})(jQuery);

$(document).ready(function () {
    if ($(".urgency-wrapper").length) {
        UrgencyAddon.initJustBoughtUrgency();
        UrgencyAddon.initOrdersUrgency();
        UrgencyAddon.initVisitorsUrgency();
    }
    $(window).on('resize', function () {
        UrgencyAddon.initBlockSizes(UrgencyAddon.boughtSelector);
        UrgencyAddon.initBlockSizes(UrgencyAddon.orderSelector);
    });
});
